import type { components } from '@feedfm/clips-services-api';

type TrackObject = components['schemas']['TrackObject'];
type CatalogFiltersType =
  components['schemas']['CurationCatalogRequest']['filters'];

/** Status badge labels shown in the catalog table */
export const STATUS_BADGE = {
  NOT_INCLUDED: 'Not included',
  LIVE: 'Live',
  LIVE_WITHOUT_COLLECTION: 'Live without collection',
  STAGED: 'Staged',
} as const;

export type StatusBadge = (typeof STATUS_BADGE)[keyof typeof STATUS_BADGE];

export const hasActiveFilters = (
  filters?: CatalogFiltersType,
): boolean => {
  if (!filters) return false;
  return Object.keys(filters).some((key) => {
    const value = (filters as any)[key];
    if (value === undefined || value === null || value === '') return false;
    if (Array.isArray(value)) return value.length > 0;
    return true;
  });
};

export const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleDateString();

export const getStatusBadge = (track: TrackObject): StatusBadge => {
  if (!track.is_included) return STATUS_BADGE.NOT_INCLUDED;
  if (track.has_curator_clip) {
    return track.collections && track.collections.length > 0
      ? STATUS_BADGE.LIVE
      : STATUS_BADGE.LIVE_WITHOUT_COLLECTION;
  }
  return STATUS_BADGE.STAGED;
};
